import { getWebInstrumentations, initializeFaro } from '@grafana/faro-react';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import env from './env.js';

const { REACT_APP_ENVIRONMENT, REACT_APP_FARO_URL } = env();

export const initFaro = () => {
  if (REACT_APP_FARO_URL) {
    return initializeFaro({
      url: REACT_APP_FARO_URL,
      app: {
        name: 'platform-ui',
        environment: REACT_APP_ENVIRONMENT ? REACT_APP_ENVIRONMENT : 'local',
      },
      sessionTracking: {
        samplingRate: 0.05,
      },
      instrumentations: [
        // Mandatory, overwriting the instrumentations array would cause the default instrumentations to be omitted
        ...getWebInstrumentations(),

        // Initialization of the tracing package.
        // This packages is optional because it increases the bundle size noticeably. Only add it if you want tracing data.
        new TracingInstrumentation({
          instrumentationOptions: {
            // Requests to these URLs will have tracing headers attached.
            propagateTraceHeaderCorsUrls: [/https:\/\/.*\.bybeam.co/],
          },
        }),
      ],
    });
  }
};
